"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var date_range_picker_styles_1 = require("./date-range-picker.styles");
var date_range_picker_containers_styles_1 = require("./date-range-picker-containers.styles");
var ArrowIndicatorUpOutline_1 = __importDefault(require("../icons/generated/ArrowIndicatorUpOutline"));
var ArrowIndicatorDownOutline_1 = __importDefault(require("../icons/generated/ArrowIndicatorDownOutline"));
var use_translated_date_hook_1 = require("./use-translated-date.hook");
var use_translations_hook_1 = __importDefault(require("../../context/translations/use-translations.hook"));
var DATEFORMAT = 'dd MMM yyyy';
var DateRangePickerHeader = function (props) {
    var getTranslation = use_translations_hook_1.default().getTranslation;
    var setInFocus = props.setInFocus, setIsOpen = props.setIsOpen, isOpen = props.isOpen, inFocus = props.inFocus, selectedDays = props.selectedDays, toggle = props.toggle, isEnabled = props.isEnabled;
    var from = selectedDays.from, to = selectedDays.to;
    var dateClick = function () {
        setInFocus('from');
        if (!isOpen && isEnabled)
            setIsOpen(true);
    };
    var formattedFrom = use_translated_date_hook_1.useTranslatedDateFormat(from, DATEFORMAT);
    var formattedTo = use_translated_date_hook_1.useTranslatedDateFormat(to, DATEFORMAT);
    var handleToggle = function () {
        if (isEnabled)
            toggle();
    };
    return (react_1.default.createElement(date_range_picker_styles_1.DateHeader, { isEnabled: isEnabled },
        react_1.default.createElement(date_range_picker_styles_1.Label, null, getTranslation('DATE_RANGE_PICKER:TIME_PERIOD')),
        react_1.default.createElement(date_range_picker_containers_styles_1.DatesContainer, { onClick: function () { return dateClick(); }, "data-test-id": "global_date_picker" },
            react_1.default.createElement(date_range_picker_styles_1.DateLabel, { isEnabled: isEnabled, inFocus: isOpen && inFocus === 'from' }, formattedFrom),
            react_1.default.createElement(date_range_picker_styles_1.DateLabel, { isEnabled: isEnabled }, "-"),
            react_1.default.createElement(date_range_picker_styles_1.DateLabel, { isEnabled: isEnabled, inFocus: isOpen && inFocus === 'to' }, formattedTo),
            (isOpen && react_1.default.createElement(ArrowIndicatorUpOutline_1.default, { onClick: handleToggle })) || react_1.default.createElement(ArrowIndicatorDownOutline_1.default, { onClick: handleToggle }))));
};
DateRangePickerHeader.displayName = 'DateRangePickerHeader';
exports.default = DateRangePickerHeader;
